import {ElasticSearchFilterValue} from '@models/elastic-search/request/elastic-search-filter-value';
import {ELASTIC_SEARCH_SORT_ORDER} from '@models/elastic-search/request/elastic-search-sort-order.enum';
import {ElasticSearchSortValue} from '@models/elastic-search/request/elastic-search-sort-value';


export class ElasticSearchRequest {
  searchText: string = '*';
  filter: ElasticSearchFilterValue[] = [];
  excludedFilter: ElasticSearchFilterValue[] = [];
  whiteListFilter: ElasticSearchFilterValue[] = [];
  from: number = 0;
  size: number = 10;
  sort: ElasticSearchSortValue = new ElasticSearchSortValue('name', ELASTIC_SEARCH_SORT_ORDER.ASC);
  fieldsToSearch: string[] = [];
  fieldsToReturn: string[] = [];
  aggregateFields: string[] = [];
}
